import { useNavigate, useOutletContext } from "react-router-dom";
import SeleccionSede from "../../../../core/ui/components/SeleccionSede";

function ReservasSedes() {
    const navigate = useNavigate();
    const { setSedeId } = useOutletContext();

    function onClickSede(sede) {
        setSedeId(sede.id);
        navigate("recursos");
    }

    return (
        <div className="px-4">
            <SeleccionSede
                onClickSede={onClickSede}
                parametrosBusquedaSedes={{ status: 1 }}
            />
        </div>
    );
}

export default ReservasSedes;
